import React from 'react'
import classNames from 'classnames'

import { MoreIcon } from 'components/Utils/Icons'
import IconButton from 'components/Utils/IconButton'
import PopoverOnClick from 'components/Utils/Popover/PopoverOnClick'
import NoteControlsMenu from 'components/Notes/Controls/Menu'

const preventDefault = (event: React.MouseEvent) => {
  // prevent the click on the dropdown button to trigger the note row Link behaviour
  event.preventDefault()
}

type ArchivedNoteControlsProps = {
  className?: string
  noteId: string
  onMorePopoverIsOpenChange: (isOpen: boolean) => void
}

export const ArchivedNoteControls = ({
  noteId,
  onMorePopoverIsOpenChange,
  className,
}: ArchivedNoteControlsProps) => (
  <div
    className={classNames('flexbox flexbox-centered shade-30', className)}
    onClick={preventDefault}
  >
    <PopoverOnClick
      position="right"
      align="start"
      onIsOpenChange={onMorePopoverIsOpenChange}
      content={({ closePopover }: { closePopover: () => void }) => (
        <NoteControlsMenu
          noteId={noteId}
          showListControls
          placement="right"
          onRowClick={closePopover}
        />
      )}
    >
      <div className="flexbox flexbox-align-center">
        <IconButton colorScheme="grayOnGray" boxSize="smaller">
          <MoreIcon size={14} />
        </IconButton>
      </div>
    </PopoverOnClick>
  </div>
)
